import _ from 'lodash';

import React from 'react';

import './styles.css';

import Select from 'components/Select';

const YEARS_TO_INCLUDE = 5;

const YearMonthSelect = ({date, today, localeUtils, onChange}) => {
  const todayDate = today.getDate();

  const months = localeUtils.getMonths();

  const currentYear = new Date().getFullYear();
  const years = _.range(
    currentYear - YEARS_TO_INCLUDE,
    currentYear + YEARS_TO_INCLUDE
  );

  const handleMonthChange = month => {
    onChange(new Date(date.getFullYear(), month.value, todayDate));
  };

  const handleYearChange = year => {
    onChange(new Date(year.value, date.getMonth(), todayDate));
  };

  return (
    <div className="DayPicker-Caption">
      <Select
        name="month"
        className="monthSelect"
        onChange={handleMonthChange}
        value={date.getMonth()}
        clearable={false}
        options={months.map((month, i) => ({label: month, value: i}))}
      />

      <Select
        name="year"
        className="yearSelect"
        onChange={handleYearChange}
        value={date.getFullYear()}
        clearable={false}
        options={years.map(year => ({label: year, value: year}))}
      />
    </div>
  );
};

export default YearMonthSelect;
